/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactSegment } from '../../models/api-response-contact-segment';
import { ContactSegment } from '../../models/contact-segment';

export interface UpdateContactSegment$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: ContactSegment
}

export function updateContactSegment(http: HttpClient, rootUrl: string, params: UpdateContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegment>> {
  const rb = new RequestBuilder(rootUrl, updateContactSegment.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactSegment>;
    })
  );
}

updateContactSegment.PATH = '/v1/api/ui/contactSegment/{ref}';
